/**
 * @module strings__escape
 * @description A set of string escaping functions
 * @see https://ru.bem.info/libraries/classic/bem-core/4.2.0/desktop/strings/#docs
 * @source https://github.com/bem/bem-core/blob/v4.2.0/common.blocks/strings/__escape/strings__escape.vanilla.js
 */
const symbols = {
  '"': "&quot;",
  "'": "&apos;",
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
};

function mapSymbol(s) {
  return symbols[s] || s;
}

function buildEscape(regexp) {
  regexp = new RegExp(regexp, "g");
  return function (str) {
    return ("" + str).replace(regexp, mapSymbol);
  };
}

export const escape = {
  /**
   * Escape string to use in XML
   * @type Function
   * @param {String} str
   * @returns {String}
   */
  xml: buildEscape("[&<>]"),

  /**
   * Escape string to use in HTML
   * @type Function
   * @param {String} str
   * @returns {String}
   */
  html: buildEscape("[&<>]"),

  /**
   * Escape string to use in attributes
   * @type Function
   * @param {String} str
   * @returns {String}
   */
  attr: buildEscape("[\"'&<>]"),
};
